enum GuideStatus {
  NOT_STARTED = "pending",
  PROGRESS = "ongoing",
  COMPLETED = "done",
}

export default GuideStatus;
